export const ERRORS_TOTAL_LIMIT: number = 2;


export default class Question {
    get theme_id(): number | null {
        return this._theme_id;
    }
    get answered(): number | null {
        return this._answered;
    }

    set answered(value: number | null) {
        this._answered = value;
    }

    get status(): boolean | null {
        return this._status;
    }

    set status(value: boolean | null) {
        this._status = value;
    }

    get answerNum(): number {
        return this._answerNum;
    }

    get answers(): string[] {
        return this._answers;
    }

    private readonly _id: number;
    private readonly _title: string;
    private readonly _img: string;
    private readonly _comment: string;
    private readonly _answerNum: number;
    private readonly _theme_id: number | null;
    private _answers: string[] = [];
    private _answered: number | null;
    private _status: boolean | null;

    public constructor(item: any) {//id: number, title: string, img: string, comment: string, answers: string, answerNum: number) {
        try {
            this._id = item.id ? item.id : item._id;
            this._title = item.title ? item.title : item._title;
            this._img = item.image ? item.image : item._img;
            this._comment = item.comment ? item.comment : item._comment;
            this.setAnswers(item.answers ? item.answers : item._answers);
            this._answerNum = item.answerNum !== undefined ? item.answerNum : item._answerNum;
            this._answered = item._answered !== undefined ? item._answered : null;
            this._status = item._status !== undefined ? item._status : null;
            this._theme_id = item.theme ? item.theme.id : null;
        } catch (e) {
            throw Error(e);
        }
    }

    get img(): string {
        return this._img;
    }

    get hint(): string {
        return this._comment;
    }

    private setAnswers(strArr: string | string[]) {
        const array: string[] = [];

        if (typeof strArr === 'string') {

            const regex = /[^""]+((?=\"\,)|(?=\"))/ig;
            const str: string = strArr.substr(1, strArr.length - 2);
            // console.log(str);
            const find: string[] | null = str.match(regex);
            // console.log(find);

            if (find) {
                for (let item of find) {
                    if (item.length > 1) {
                        item = item.split('\\').join('');
                        array.push(item);
                    }
                }
            }

        } else if (Array.isArray(strArr)) {
            for (let item of strArr) {
                array.push(item);
            }
        }

        this._answers = array;
    }

    get title(): any {
        return this._title;
    }
}

